import { HeadContent } from '@fourthwall/components';
import React from 'react';
import { Dashboard } from '@components/common';
import { GiveawayPackagesData } from './components/GiveawayPackagesData';
export const GiveawayPackagesView = ({ tableProps }) => (React.createElement(React.Fragment, null,
    React.createElement(HeadContent, { title: "Giveaway links" }),
    React.createElement(Dashboard.Section.Item, null,
        React.createElement(GiveawayPackagesData, { ...tableProps }))));
